import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledButtonContainer = styled(StyledFlex)`
   width: 100%;
`;

export const StyledAdContainer = styled(StyledFlex)`
   width: 63%;
`;

StyledAdContainer.displayName = 'StyledAdContainer';
